var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimpleStar = function SvgIconFolderSimpleStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5V6.25h4.664l2.54 1.9.002.002a1.76 1.76 0 0 0 1.043.348H20v2a1 1 0 1 0 2 0V8.25a1.75 1.75 0 0 0-1.75-1.75h-7.914l-2.54-1.9-.002-.002A1.76 1.76 0 0 0 8.75 4.25H3.75A1.75 1.75 0 0 0 2 6v12.75a1.75 1.75 0 0 0 1.75 1.75h6.75a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.544 11.605a1 1 0 0 0-1.838 0l-1.008 2.342-2.65.206a1 1 0 0 0-.56 1.768l1.99 1.643-.608 2.445a1 1 0 0 0 1.478 1.103l2.277-1.342 2.277 1.342a1 1 0 0 0 1.478-1.103l-.608-2.445 1.99-1.643a1 1 0 0 0-.56-1.768l-2.65-.206zm-1.247 3.687.328-.763.328.763a1 1 0 0 0 .841.602l.786.061-.567.468a1 1 0 0 0-.334 1.012l.185.744-.731-.431a1 1 0 0 0-1.016 0l-.731.431.184-.744a1 1 0 0 0-.333-1.012l-.567-.468.786-.061a1 1 0 0 0 .84-.602",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderSimpleStar;